import { useState, useEffect } from "preact/hooks";

export function useFetchItems({ type, ids }) {
  const [page, setPage] = useState("");
  useEffect(() => {
    if (!ids || ids.length === 0) {
      setPage("");
      return;
    }
    let cancelled = false;

    async function fetchPage() {
      try {
        let url = window.Routing.generate("_storage_items." + lang, {
          ids: type === "history" ? ids.map((i) => i.id) : ids,
          type,
        });
        const response = await fetch(url);
        const html = await response.text();
        if (!cancelled) setPage(html);
      } catch {
        if (!cancelled) setPage("");
      }
    }

    fetchPage();
    return () => {
      cancelled = true;
    };
  }, [type, ids]);
  return page;
}
